import DescriptionIcon from '@mui/icons-material/Description';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const TravelDocumentsCard = () => (
  <ToolCard
    icon={<DescriptionIcon fontSize="large" />}
    title="Kelionės dokumentai"
    description="Čia galite redaguoti kelionės dokumentus kuriuos svetainės vartotojai galės prisegti prie užsakymo savitarnoje"
    action={
      <Button
        href="travel-documents"
        startIcon={<DescriptionIcon />}
        size="small">
        Redaguoti
      </Button>
    }
  />
);

export default TravelDocumentsCard;
